/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCUpIcon64Regular = forwardRef('ArrowCUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M9.94 42.06a1.5 1.5 0 0 1 0-2.12l16.757-16.758a7.5 7.5 0 0 1 10.606 0l16.758 16.757a1.5 1.5 0 0 1-2.122 2.122L35.182 25.303a4.5 4.5 0 0 0-6.364 0L12.061 42.061a1.5 1.5 0 0 1-2.122 0Z" })));
});
